import { render, staticRenderFns } from "./Fullpagelist.vue?vue&type=template&id=0f32ae05&scoped=true&"
import script from "./Fullpagelist.vue?vue&type=script&lang=js&"
export * from "./Fullpagelist.vue?vue&type=script&lang=js&"
import style0 from "./Fullpagelist.vue?vue&type=style&index=0&id=0f32ae05&scoped=true&lang=css&"
import style1 from "./Fullpagelist.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f32ae05",
  null
  
)

export default component.exports